// La liste des groupes est passée à React — et elle partage désormais son
// composant avec la liste des pages, dont elle ne différait que par des mots.
//
// Ce qui vivait ici a été réparti :
//   · la nomenclature des types  → js/espaces-meta.js
//   · la fenêtre de création     → js/views/espaces-creer.js
//   · l'écran                    → js/react/ecrans/Espaces.jsx
// L'ancienne version (d'avant React) a été retirée le 20 octobre 2026 —
// archivée hors du dépôt : ~/Desktop/koinonia-archive-code-retire-2026-10-20.zip.
import { vueReact } from "../react/pont.jsx";
import { Groupes } from "../react/ecrans/Espaces.jsx";

export { TYPES_GROUPE, typeDe } from "../espaces-meta.js";
export { creerGroupe } from "./espaces-creer.js";

export const rendre = vueReact(Groupes);
